export const selectFormStore = (store) => store.form;
